import { IconShieldCheck } from '@iwoca/icons';
import { Button, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

const TRUELAYER_FRN = '901096';

export const ReconfirmConsent = ({
    onContinue
}: {
    onContinue: () => void;
}) => {
    return (
        <div className="space-y-s">
            <Text size="s">
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.consent_context"
                    defaultMessage="You previously linked your bank account for 90 days. Renew your connection so that iwoca can continue to give you the best options for your business."
                />
            </Text>

            <div className="!mt-xl space-y-s rounded-m bg-structure-95 p-m">
                <div className="flex items-center gap-s">
                    <IconShieldCheck />
                    <Text className="text-xs font-bold">
                        <FormattedMessage
                            id="_.bank_selection_modal.bank_grade_encryption"
                            defaultMessage="Bank-grade encryption"
                        />
                    </Text>
                </div>
                <Text className="text-s">
                    <FormattedMessage
                        id="_.bank_selection_modal.reconsent.encryption_body"
                        defaultMessage="Your bank connection is protected with bank-grade encryption, and iwoca never sees your bank login details."
                    />
                </Text>
            </div>

            <Text size="s" className="!mt-l">
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.consent_intro"
                    defaultMessage="Our Open Banking partner, TrueLayer, needs your permission to access the following information and share it with iwoca:"
                />
            </Text>

            <ul className="list-outside list-disc pl-xl text-s font-reg marker:text-[0.6em]">
                <li>
                    <FormattedMessage
                        id="_.bank_selection_modal.full_name"
                        defaultMessage="Full name"
                    />
                </li>
                <li>
                    <FormattedMessage
                        id="_.bank_selection_modal.account_number_and_sort_code"
                        defaultMessage="Account number and sort code"
                    />
                </li>
                <li>
                    <FormattedMessage
                        id="_.bank_selection_modal.balance"
                        defaultMessage="Balance"
                    />
                </li>
                <li>
                    <FormattedMessage
                        id="_.bank_selection_modal.transaction_history"
                        defaultMessage="Transactions, direct debits, and standing orders"
                    />
                </li>
            </ul>

            <Text size="s">
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.consent_duration"
                    defaultMessage="Your renewed permission will last another <b>90 days</b>. We’ll ask you again after that, so you stay in control of your data."
                    values={{
                        b: (chunks) => (
                            <span className="font-bold">{chunks}</span>
                        )
                    }}
                />
            </Text>

            <Button
                variant="primary-rounded"
                className="!mt-l w-full"
                onClick={onContinue}
            >
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.consent_continue"
                    defaultMessage="Renew my connection"
                />
            </Button>

            <Text
                size="xs"
                className="!mt-[10px] text-center font-reg text-structure-20"
            >
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.consent_footer"
                    defaultMessage="By tapping ‘Renew my connection’, you agree to {tosLink} and {privacyLink}. TrueLayer is authorised by the Financial Conduct Authority, firm reference number {frn}."
                    values={{
                        frn: TRUELAYER_FRN,
                        tosLink: (
                            <a
                                className="text-primary-40"
                                href="https://truelayer.com/legal/enduser_tos/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FormattedMessage
                                    id="_.bank_selection_modal.agreement_tos"
                                    defaultMessage="TrueLayer’s Terms of Service"
                                />
                            </a>
                        ),
                        privacyLink: (
                            <a
                                className="text-primary-40"
                                href="https://truelayer.com/privacy"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FormattedMessage
                                    id="_.bank_selection_modal.agreement_privacy"
                                    defaultMessage="Privacy Policy"
                                />
                            </a>
                        )
                    }}
                />
            </Text>
        </div>
    );
};
